
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Card, CardContent } from '@/components/ui/card';
import { Form } from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { BlogPost } from '@/services/blog/types';
import { TitleSlugFields } from './form-fields/TitleSlugFields';
import { ContentFields } from './form-fields/ContentFields';
import { MediaFields } from './form-fields/MediaFields';
import { TagsManager } from './form-fields/TagsManager';
import { SEOFields } from './form-fields/SEOFields';
import { PublishingControls } from './form-fields/PublishingControls';

interface BlogFormData {
  title?: string;
  slug?: string;
  content?: string;
  summary?: string;
  tags?: string[];
  published?: boolean;
  meta_title?: string;
  meta_description?: string;
  author_name?: string;
  featured_image?: string;
}

interface BlogFormProps {
  form: UseFormReturn<BlogFormData>;
  onSubmit: (data: BlogFormData) => void;
  isSubmitting: boolean;
  mode: 'create' | 'edit';
  post?: BlogPost;
  isLoading?: boolean;
  handleSave?: () => void;
}

export const BlogForm: React.FC<BlogFormProps> = ({
  form,
  onSubmit,
  isSubmitting,
  mode,
}) => {
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <Tabs defaultValue="content" className="w-full">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="content">Content</TabsTrigger>
            <TabsTrigger value="seo">SEO</TabsTrigger>
            <TabsTrigger value="publish">Publish</TabsTrigger>
          </TabsList>

          <TabsContent value="content" className="space-y-6">
            <Card>
              <CardContent className="p-6 space-y-6">
                <TitleSlugFields form={form} />
                <ContentFields form={form} />
                <MediaFields form={form} />
                <TagsManager form={form} />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="seo" className="space-y-6">
            <Card>
              <CardContent className="p-6 space-y-6">
                <SEOFields form={form} />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="publish" className="space-y-6">
            <Card>
              <CardContent className="p-6 space-y-6">
                <PublishingControls form={form} />

                <div className="flex justify-end space-x-4 pt-6 border-t">
                  <Button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : mode === 'create' ? 'Create Post' : 'Update Post'}
                  </Button>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </form>
    </Form>
  );
};
